import React from 'react';
import classnames from 'classnames';

import styles from './Loader.module.scss';
import { LoaderType } from './Loader.types';

export default function Loader({ className }: LoaderType): React.ReactElement {
  return <div className={classnames(styles.loader, className)} />;
}
